import type {
  AdminShareDecision,
  AdminShareReviewResponse,
  CashbackSummary,
  ShareLinksResponse,
} from '@pulsify/shared/dto'
import { api, unwrap } from '~/shared/lib/rpc'

export type ShareLinkOwner = { kind: 'event' | 'profile'; id: string }

export const shareLinksApi = {
  async forTarget(businessId: string, target: ShareLinkOwner): Promise<ShareLinksResponse> {
    const res =
      target.kind === 'event'
        ? await api.api.businesses[':businessId'].events[':eventId']['share-links'].$post({
            param: { businessId, eventId: target.id },
          })
        : await api.api.businesses[':businessId'].profiles[':profileId']['share-links'].$post({
            param: { businessId, profileId: target.id },
          })
    return unwrap<ShareLinksResponse>(res)
  },

  async cashback(businessId: string): Promise<CashbackSummary> {
    const res = await api.api.businesses[':businessId'].cashback.$get({ param: { businessId } })
    return unwrap<CashbackSummary>(res)
  },

  async adminReview(): Promise<AdminShareReviewResponse> {
    const res = await api.api.admin['share-cashback'].$get()
    return unwrap<AdminShareReviewResponse>(res)
  },

  async adminDecide(id: string, decision: AdminShareDecision['decision']): Promise<void> {
    await unwrap(
      await api.api.admin['share-cashback'][':id'].$post({ param: { id }, json: { decision } }),
    )
  },
}
